import 'bootstrap-datepicker'
import moment from 'moment'
import { handleFilterResponse, postFilters } from './functions'

const accountDateFormat = localStorage.getItem('accountDateFormat')

const datepickerOptions = {
  autoclose: true,
  format: accountDateFormat,
  zIndexOffset: '2000'
}

// Date Picker Functionality
function initDatepicker (filterKeyType, callback, isActiveFiltering = true) {
  $('#from-date, #to-date').datepicker(datepickerOptions).on('changeDate', function (e) {
    if (isActiveFiltering) {
      $('#loadingIcon').show()
    }

    if (e.date == null) {
      return
    }

    const dateFromInput = moment.utc($('#from-date').data('datepicker').getDate())
    const dateToInput = moment.utc($('#to-date').data('datepicker').getDate()).add(1, 'd').subtract(1, 's')

    if (dateFromInput.isValid()) {
      filters[filterKeyType + '_filters'].from_date = dateFromInput.unix()
    }

    if (dateToInput.isValid()) {
      filters[filterKeyType + '_filters'].to_date = dateToInput.unix()
    }

    if (dateFromInput.isValid() || dateToInput.isValid()) {
      if (!callback) {
        callback = (results) => {
          handleFilterResponse(results)
          localStorage.setItem(filterKeyType + '_filters', JSON.stringify(filters))
          const event = new Event('FilterResultsUpdated')
          document.dispatchEvent(event)
        }
      }

      if (isActiveFiltering) {
        postFilters(refreshPath, filters, filterKeyType, callback)
      }
    }

    const event = new Event('FiltersUpdated')
    document.dispatchEvent(event)
  })

  $('#dateClear').click(function () {
    if (isActiveFiltering) {
      $('#loadingIcon').show()
    }
    $('#from-date').datepicker('clearDates')
    $('#to-date').datepicker('clearDates')

    filters[filterKeyType + '_filters'].from_date = null
    filters[filterKeyType + '_filters'].to_date = null

    if (!callback) {
      callback = (results) => {
        handleFilterResponse(results)
        localStorage.setItem(filterKeyType + '_filters', JSON.stringify(filters))
        const event = new Event('FilterResultsUpdated')
        document.dispatchEvent(event)
      }
    }

    if (isActiveFiltering) {
      postFilters(refreshPath, filters, filterKeyType, callback)
    }

    const event = new Event('FiltersUpdated')
    document.dispatchEvent(event)
  })
}

export { initDatepicker }
